"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("../styles");

var _icons = _interopRequireDefault(require("../icons"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Result =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(Result, _PureComponent);

  function Result(props) {
    var _this;

    _this = _PureComponent.call(this, props) || this;
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleRecover = _this.handleRecover.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  var _proto = Result.prototype;

  _proto.handleRemove = function handleRemove() {
    this.props.onRemove(this.props.index);
  };

  _proto.handleRecover = function handleRecover() {
    var _this$props = this.props,
        onRecover = _this$props.onRecover,
        value = _this$props.value,
        index = _this$props.index;
    onRecover(index, value);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        renderResult = _this$props2.renderResult,
        value = _this$props2.value,
        recoverAble = _this$props2.recoverAble,
        showRecover = _this$props2.showRecover;
    var className = (0, _styles.uploadClass)('view-value', recoverAble && 'to-be-delete');
    return _react.default.createElement("div", {
      className: className
    }, _react.default.createElement("div", {
      className: (0, _styles.uploadClass)('text')
    }, renderResult(value)), this.props.onRemove && _react.default.createElement("a", {
      href: "javascript:;",
      className: (0, _styles.uploadClass)('delete'),
      onClick: this.handleRemove
    }, _icons.default.Close), showRecover && _react.default.createElement("a", {
      href: "javascript:;",
      className: (0, _styles.uploadClass)('recover'),
      onClick: this.handleRecover
    }, _icons.default.Recovery));
  };

  return Result;
}(_react.PureComponent);

Result.propTypes = {
  index: _propTypes.default.number,
  onRemove: _propTypes.default.func,
  onRecover: _propTypes.default.func,
  recoverAble: _propTypes.default.bool,
  renderResult: _propTypes.default.func,
  showRecover: _propTypes.default.bool,
  value: _propTypes.default.any
};
Result.defaultProps = {
  renderResult: function renderResult(a) {
    return a;
  },
  recoverAble: false
};
var _default = Result;
exports.default = _default;